import React, { useEffect, useState } from 'react';
import axios from 'axios';
import qs from 'qs';
import { ReactComponent as Check } from '../Img/icon-check.svg';
import { ReactComponent as Add } from '../Img/icon-add.svg';
import { useForm } from "react-hook-form";
import 'react-notifications/lib/notifications.css';
import {NotificationManager} from 'react-notifications';
import Dialog from "./Dialog";

const OrganismeAdresse = (props) =>
{
    const [adresse, setAdresse] = useState(null);
    const [id_organisme, setId_organisme] = useState('');
    const [nom_voie, setNom_voie] = useState('');
    const [num_voie, setNum_voie] = useState('');
    const [num_suffixe, setNum_suffixe] = useState('');
    const [type_voie, setType_voie] = useState('');
    const [complement_adresse, setComplement_adresse] = useState('');
    const [code_postale, setCode_postale] = useState('');
    const [ville, setVille] = useState('');
    
    // état pour Dialog personnalisé
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogMessage, setDialogMessage] = useState('');

    const green = '#59B44A';
    const purple = '#6571FE';
    
    const [dialogModalVisible, setDialogModalVisible] = useState(false);
    
    async function callbackDialog(ret) {
        if (ret === true) {
            deleteAdresse();
        }
    }

    async function mount()
    {
        if (props.user && props.user.id_organisme)
        {
            setId_organisme(String(props.user.id_organisme));
            
            await axios.post('/api/organismes_adresse.php', qs.stringify({
                'get': true,
                'id_organisme': props.user.id_organisme
            }))
            .then((res) => {
                if (res && res.data) {
                    setNum_voie(res.data.num_voie !== null && res.data.num_voie !== undefined ? String(res.data.num_voie) : '');
                    setNum_suffixe(res.data.num_suffixe || '');
                    setType_voie(res.data.type_voie || '');
                    setNom_voie(res.data.nom_voie || '');
                    setComplement_adresse(res.data.complement_adresse || '');
                    setCode_postale(res.data.code_postale || '');
                    setVille(res.data.ville || '');
                }
                else {
                    clearForm();
                }
            })
            .catch((err) => {
                console.warn(err)
            })
        }
    }

    useEffect(() => {
        mount();
    }, [props.user]);

    const clearForm = () => {
        setNom_voie('');
        setNum_voie('');
        setNum_suffixe('');
        setType_voie('');
        setComplement_adresse('');
        setCode_postale('');
        setVille('');
    };

    const updateAdresse = async () => {
        if (!nom_voie || !nom_voie.trim()) {
            setDialogMessage("Le champ « Nom de la voie » est requis.");
            setDialogOpen(true);
            return;
        }
        try {
            const params = {
                update: true,
                id_organisme: id_organisme,
                num_voie: num_voie,
                num_suffixe: num_suffixe,
                type_voie: type_voie,
                nom_voie: nom_voie,
                complement_adresse: complement_adresse,
                code_postale: code_postale,
                ville: ville
            };
            const res = await axios.post('/api/organismes_adresse.php', qs.stringify(params));
            if (res && res.data && res.data.status === 1) {
                NotificationManager.success("Adresse mise à jour avec succès.", '', 2000);
                await mount();
            } else {
                const msg = res && res.data && res.data.message ? res.data.message : 'Erreur mise à jour adresse';
                NotificationManager.error(msg, '', 4000);
                console.warn('Erreur mise à jour adresse', res && res.data ? res.data : res);
            }
        } catch (e) {
            NotificationManager.error("Erreur lors de la requête de mise à jour.", '', 4000);
            console.error(e);
        }
    };

    const deleteAdresse = async () => {
        if (!adresse || !adresse.id) return;
        try {
            const params = {
                delete: true,
                id: adresse.id
            };
            const res = await axios.post('/api/organismes_adresse.php', qs.stringify(params));
            if (res && res.data && res.data.status === 1) {
                NotificationManager.success("Adresse supprimée.", '', 2000);
                await mount();
            } else {
                const msg = res && res.data && res.data.message ? res.data.message : 'Erreur suppression adresse';
                NotificationManager.error(msg, '', 4000);
                console.warn('Erreur suppression adresse', res && res.data ? res.data : res);
            }
        } catch (e) {
            NotificationManager.error("Erreur lors de la requête de suppression.", '', 4000);
            console.error(e);
        }
    };

	return (
        <div className='shadow-md' style={{textAlign: 'left',  borderRadius: 3, padding: 20, margin: 1, backgroundColor: 'white'}}>
            <div style={{textAlign: 'center'}}>
                <p style={{fontWeight: 'bold', fontSize: 16, marginBottom: 20, color: purple}}>Adresse postale</p>
            </div>

            <Dialog
                setModalVisible={setDialogModalVisible}
                modalVisible={dialogModalVisible}
                callbackDialog={callbackDialog}
                message={"Confirmez la suppression :"}
            />

            <div style={{display: 'flex', flexWrap: 'wrap', gap: 12}}>
                <div style={{flex: '1 1 45%'}}>
                    <label style={{display: 'block', marginBottom: 6, fontWeight: 600}}>Numéro de voie</label>
                    <input value={num_voie} onChange={e => setNum_voie(e.target.value)} style={{width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc'}} placeholder="Ex: 12" />
                </div>

                <div style={{flex: '1 1 45%'}}>
                    <label style={{display: 'block', marginBottom: 6, fontWeight: 600}}>Numéro suffixe (BIS, TER...)</label>
                    <input value={num_suffixe} onChange={e => setNum_suffixe(e.target.value)} style={{width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc'}} placeholder="Ex: BIS" />
                </div>

                <div style={{flex: '1 1 45%'}}>
                    <label style={{display: 'block', marginBottom: 6, fontWeight: 600}}>Type de voie</label>
                    <select value={type_voie} onChange={e => setType_voie(e.target.value)} style={{width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc'}}>
                        <option value="">-- Sélectionner --</option>
                        <option>Rue</option>
                        <option>Avenue</option>
                        <option>Boulevard</option>
                        <option>Chemin</option>
                        <option>Impasse</option>
                        <option>Place</option>
                        <option>Allée</option>
                        <option>Route</option>
                    </select>
                </div>

                <div style={{flex: '1 1 45%'}}>
                    <label style={{display: 'block', marginBottom: 6, fontWeight: 600}}>Nom de la voie</label>
                    <input value={nom_voie} onChange={e => setNom_voie(e.target.value)} style={{width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc'}} placeholder="Nom de la voie" />
                </div>

                <div style={{width: '100%'}}>
                    <label style={{display: 'block', marginBottom: 6, fontWeight: 600}}>Complément d'adresse</label>
                    <input value={complement_adresse} onChange={e => setComplement_adresse(e.target.value)} style={{width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc'}} placeholder="Bâtiment, étage, BP..." />
                </div>

                <div style={{flex: '1 1 45%'}}>
                    <label style={{display: 'block', marginBottom: 6, fontWeight: 600}}>Code postal</label>
                    <input value={code_postale} onChange={e => setCode_postale(e.target.value)} style={{width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc'}} placeholder="Ex: 75001" />
                </div>

                <div style={{flex: '1 1 45%'}}>
                    <label style={{display: 'block', marginBottom: 6, fontWeight: 600}}>Ville</label>
                    <input value={ville} onChange={e => setVille(e.target.value)} style={{width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc'}} placeholder="Ville" />
                </div>
            </div>

            <div style={{display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 20}}>
                {adresse ? (
                    <button
                        onClick={() => setDialogModalVisible(true)}
                        style={{padding: '8px 12px', borderRadius: 4, backgroundColor: '#d9534f', color: 'white', border: 'none', cursor: 'pointer'}}
                    >
                        Supprimer
                    </button>
                ) : (
                    <button
                        onClick={updateAdresse}
                        style={{padding: '8px 12px', borderRadius: 4, backgroundColor: green, color: 'white', border: 'none', cursor: 'pointer'}}
                    >
                        Mettre à jour
                    </button>
                )}
            </div>
        </div>
	);
}

export default OrganismeAdresse;
